import styled from 'styled-components';

export const Content = styled.main`
  height: calc(100vh - 136px);
`;
